










































import Card from '@components/ArticleCard.vue'
import WrappedLink from '@components/WrappedLink.vue'
import Placeholder from '@components/placeholders/ArticleCardPlaceholder.vue'
import { Category, ArticleCard, ContentItem } from '@/types/content'
import get from 'lodash/get'
import wrappers from '@/mixins/wrappers'
import utils from '@/mixins/utils'
import mixins from 'vue-typed-mixins'
import overlays from '@/mixins/overlays'
import eventTracker from '@/utils/eventTracker'
export default mixins(utils, overlays, wrappers).extend({
  name: 'LearningArticles',
  components: {
    Card,
    Placeholder,
    WrappedLink
  },
  props: {
    categoryId: String
  },
  data () {
    return {
      category: null as Category | null,
      loading: false
    }
  },
  computed: {
    wrapped (): Record<string, any> {
      return {
        refresh: this.offlineWrapper(this.refresh),
        bookmarkClicked: this.offlineWrapper(this.bookmarkClicked)
      }
    },
    categories (): Category[] {
      return this.$store.getters['user/content/categories']
    },
    cards (): ArticleCard[] {
      const rawData: ContentItem[] = this.$store.getters['user/content/content']
      const result = rawData.map(
        r => {
          const imageUrl = get(r, 'cmsContent.imgUrl') || 'https://via.placeholder.com/308x172'
          const title = get(r, 'cmsContent.title', 'N/A')
          const description = this.contentBodyToText(get(r, 'cmsContent.body'))
          const bookmarked = get(r, 'userBookmarked', false)
          const contentId = get(r, 'cmsContent.id')
          const category = get(r, 'cmsContent.category')
          return {
            imageUrl, title, description, bookmarked, contentId, category
          }
        }
      )
      return result
    }
  },
  watch: {
    categoryId: {
      handler () {
        this.wrapped.refresh()
      },
      immediate: true
    }
  },
  methods: {
    async refresh () {
      this.category = this.categories.find(({ id }) => id === this.categoryId) || null
      if (this.category) {
        this.loading = true
        try {
          await this.$store.dispatch('user/content/LoadContent', { categoryId: this.category.id })
          eventTracker.track('Learn Category', { categoryId: this.category.id })
        }
        finally {
          this.loading = false
        }
      }
    },
    async bookmarkClicked ({ contentId, bookmarked, category }: ArticleCard) {
      const undo = bookmarked
        ? Promise.resolve(false)
        : this.showSnackbar(this.$t('snackbars.articleBookmarked'), {
          showUndo: true
        })
      const bookmarkUpdated = await this.$store.dispatch(
        'user/content/UpdateBookmark',
        {
          contentId,
          value: !bookmarked,
          undo
        }
      )
      if (bookmarkUpdated) {
        eventTracker.track('LearnCategory Bookmark', {
          bookmark: bookmarked ? 0 : 1,
          contentId,
          category
        })
      }
    }
  }
})
